import { Button, Switch, Popconfirm } from "antd";

export const getColumns = ({ handleToggleAdmin, handleEdit, handleDelete }) => {
  return [
    { title: "User Name", dataIndex: "name", key: "name" },
    { title: "User Email", dataIndex: "email", key: "email" },
    {
      title: "Role",
      dataIndex: "isAdmin",
      key: "isAdmin",
      render: (text, record) => (
        <Switch
          checked={record.isAdmin}
          onChange={() => handleToggleAdmin(record._id)}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this user?"
            onConfirm={() => handleDelete(record._id)}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
};
